<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Contact Info"
    seFeDataSubtitle="A contact info component"
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <se-fe-card>
      <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
      <se-fe-card-content>
        <p>Use this component for contact info inputs</p>
        <p>Uses the following ui-components</p>
        <ul>
          <li>
            <a routerLink="/libs/ui-email">&#64;se-po/shared-ui-email</a>
          </li>
          <li>
            <a routerLink="/libs/ui-phone">&#64;se-po/shared-ui-phone</a>
          </li>
        </ul>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card>
      <se-fe-card-header seFeDataTitle="ContactInfoValueFields"></se-fe-card-header>
      <se-fe-card-content>
        <se-fe-docs-table
          [seFeDataHeaders]="headers"
          [seFeDataRows]="contactInfoValueFields">
        </se-fe-docs-table>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card class="form-example">
      <se-fe-card-header seFeDataTitle="Example Code"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-contact-info-example></se-po-contact-info-example>
      </se-fe-card-content>
    </se-fe-card>
  </div>
</se-fe-page>
<se-fe-toast></se-fe-toast>
